import { render, staticRenderFns } from "./CardTransactionLedger.vue?vue&type=template&id=f1b1f260&scoped=true"
import script from "./CardTransactionLedger.vue?vue&type=script&lang=js"
export * from "./CardTransactionLedger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b1f260",
  null
  
)

export default component.exports